// extracted by mini-css-extract-plugin
export var link = "_vo-0";